<app-header #header title="Profile Information"></app-header>


<ion-content fullscreen="true" scrollEvents="true" [appHideHeader]="header">
  <app-loading-spinner  *ngIf="!loaded"></app-loading-spinner>
  <ion-card *ngIf="loaded"
  style="
    border-radius: 0.85em 0.85em 0 0;
    margin: 0.5em 0.2em;
    border: none;
    min-height: 100%;
    padding: 0.2em;
  "
>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <h1 style="text-align: center; font-weight: bold; color: black">
          {{  ('keys.data.user_menu.company_users' | translate : {Default:'Company Users'}) ||
          'Company Users' }}
        </h1>
      </ion-col>
    </ion-row>
    <ion-row *ngFor="let employee of employees">
      <ion-col  size-xs="11"
      offset-xs="0.5"
      size-md="9"
      offset-md="1.5"
      size-lg="8"
      offset-lg="2"
      size-xl="7"
      offset-xl="2.5">
        <ion-card>
          <ion-grid>
            <ion-row >
                  <ion-col style="padding: 0.4em;">
                    <ion-label style="color: var(--Black-shade, #161616);
                    font-feature-settings: 'clig' off, 'liga' off;
                    
                    /* heading cards */
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 16px; /* 133.333% */
                    letter-spacing: 1.5px;
                    text-transform: uppercase;"> {{ employee['firstName']}} {{ employee['lastName']}}</ion-label>
                     
                  </ion-col>
                </ion-row>
              <ion-row>
                <ion-col >
                  <ion-accordion-group multiple="true" >
                    
                      <ion-accordion
                        toggleIcon="caret-down"
                      >
                      <ion-item slot="header"  >
                        <ion-label>
                          {{  ('keys.data.vehicles.vehicles' | translate : {Default:'Vehicles'}) ||
                          "Vehicles" }}:
                        </ion-label>
                        <ion-chip class="ion-text-right">{{employee['vehicles'].length}}</ion-chip>
                      </ion-item>
                      <div class="ion-padding" slot="content">
                        <ion-card>
                          <ion-item *ngFor="let vehicle of employee['vehicles']" style="text-align: center">
                            <ion-label>
                              {{vehicle['plate']}}
                            </ion-label>
                            </ion-item>
                            </ion-card>
                      </div>
                      </ion-accordion>
                      <ion-accordion *ngIf="employee['permits'].length>0"
                          toggleIcon="caret-down"
                        >
                        <ion-item slot="header" >
                          <ion-label>
                            {{  ('keys.data.permits.active_permits' | translate : {Default:'Active Permits'}) ||
                            "Active Permits" }}:
                          </ion-label>
                          <ion-chip class="ion-text-right">{{employee['permits'].length}}</ion-chip>
                        </ion-item>
                        <div class="ion-padding" slot="content">
                          <ion-card>
                            <ion-item *ngFor="let permit of employee['permits']" style="text-align: center">
                              <ion-label>
                                {{permit['permitNo']}}
                              </ion-label>
                              </ion-item>
                              </ion-card>
                        </div>
                        </ion-accordion>
                      
                      </ion-accordion-group>

                    
                </ion-col>
                
                </ion-row>
                
                  <ion-row>
                    <ion-col size="8" offset="2">
                      <ion-button *ngIf="dataService.user['UserID']!=employee['UserID']"  [disabled]="dataService.isTemp" (click)="loginAsEmployee(employee['UserID'])" expand="block" color="primary">
                        {{  ('keys.data.users_login.login_as_user' | translate : {Default:'Login as User'}) ||
                        "Login as User" }}
                      </ion-button>
                    </ion-col>
                  </ion-row>
          </ion-grid>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  </ion-card>
</ion-content>
